import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminDataCreateDto } from '../dtos/admindata/adminDataCreateDto';
import { ContactCreateDto } from '../dtos/contact/contactCreateDto';
import { SmsAccountCreateDto } from '../dtos/smsAccount/smsAccountCreateDto';
import { SmsTemplateCreateDto } from '../dtos/smsTemplate/smsTemplateCreateDto';
import { SmtpCreateDto } from '../dtos/smtp/smtpCreateDto';
import { AdminDataUpdateDto } from '../dtos/admindata/adminDataUpdateDto';
import { SmsAccountUpdateDto } from '../dtos/smsAccount/smsAccountUpdateDto';
import { ContactUpdateDto } from '../dtos/contact/contactUpdateDto';
import { SmsTemplateUpdateDto } from '../dtos/smsTemplate/smsTemplateUpdateDto';
import { SmtpUpdateDto } from '../dtos/smtp/smtpUpdateDto';

@Injectable({
  providedIn: 'root'
})
export class DefinationService {

  constructor(private http: HttpClient) { }

  public apiUrlAdminData = `${environment.apiUrl}/adminDatas`;
  public apiUrlContact = `${environment.apiUrl}/contacts`;
  public apiUrlSmsAccount = `${environment.apiUrl}/smsAccounts`;
  public apiUrlSmsTemplate = `${environment.apiUrl}/smsTemplates`;
  public apiUrlSmtp = `${environment.apiUrl}/smtps`;

  getListAdminData(): Observable<any> {
    return this.http.get(`${this.apiUrlAdminData}`)
  }
  getListContact(): Observable<any> {
    return this.http.get(`${this.apiUrlContact}`)
  }
  getListSmsAccount(): Observable<any> {
    return this.http.get(`${this.apiUrlSmsAccount}`)
  }
  getListSmsTemplate(): Observable<any> {
    return this.http.get(`${this.apiUrlSmsTemplate}`)
  }
  getListSmtp(): Observable<any> {
    return this.http.get(`${this.apiUrlSmtp}`)
  }
  getSmtpName(): Observable<any> {
    return this.http.get(`${this.apiUrlSmtp}/GetSmtpName`)
  }


  getByIdAdminData(id: number): Observable<any> {
    return this.http.get(`${this.apiUrlAdminData}/${id}`)
  }
  getByIdContact(id: number): Observable<any> {
    return this.http.get(`${this.apiUrlContact}/${id}`)
  }
  getByIdSmsAccount(id: number): Observable<any> {
    return this.http.get(`${this.apiUrlSmsAccount}/${id}`)
  }
  getByIdSmsTemplate(id: number): Observable<any> {
    return this.http.get(`${this.apiUrlSmsTemplate}/${id}`)
  }
  getByIdSmtp(id: number): Observable<any> {
    return this.http.get(`${this.apiUrlSmtp}/${id}`)
  }

  createAdminData(adminDataCreateDto: AdminDataCreateDto) {
    return this.http.post(`${this.apiUrlAdminData}`, adminDataCreateDto)
  }
  createContact(contactCreateDto: ContactCreateDto) {
    return this.http.post(`${this.apiUrlContact}`, contactCreateDto)
  }
  createSmsAccount(smsAccountCreateDto: SmsAccountCreateDto) {
    return this.http.post(`${this.apiUrlSmsAccount}`, smsAccountCreateDto)
  }
  createSmsTemplate(smsTemplateCreateDto: SmsTemplateCreateDto) {
    return this.http.post(`${this.apiUrlSmsTemplate}`, smsTemplateCreateDto)
  }
  createSmtp(smtpCreateDto: SmtpCreateDto) {
    return this.http.post(`${this.apiUrlSmtp}`, smtpCreateDto)
  }

  updateAdminData(id: number, adminDataUpdateDto: AdminDataUpdateDto) {
    return this.http.put(`${this.apiUrlAdminData}/${id}`, adminDataUpdateDto)
  }
  updateContact(id: number, contactUpdateDto: ContactUpdateDto) {
    return this.http.put(`${this.apiUrlContact}/${id}`, contactUpdateDto)
  }
  updateSmsAccount(id: number, smsAccountUpdateDto: SmsAccountUpdateDto) {
    return this.http.put(`${this.apiUrlSmsAccount}/${id}`, smsAccountUpdateDto)
  }
  updateSmsTemplate(id: number, smsTemplateUpdateDto: SmsTemplateUpdateDto) {
    return this.http.put(`${this.apiUrlSmsTemplate}/${id}`, smsTemplateUpdateDto)
  }
  updateSmtp(id: number, smtpUpdateDto: SmtpUpdateDto) {
    return this.http.put(`${this.apiUrlSmtp}/${id}`, smtpUpdateDto)
  }

  deleteAdminData(id: number) {
    return this.http.delete(`${this.apiUrlAdminData}/${id}`)
  }
  deleteContact(id: number) {
    return this.http.delete(`${this.apiUrlContact}/${id}`)
  }
  deleteSmsAccount(id: number) {
    return this.http.delete(`${this.apiUrlSmsAccount}/${id}`)
  }
  deleteSmsTemplate(id: number) {
    return this.http.delete(`${this.apiUrlSmsTemplate}/${id}`)
  }
  deleteSmtp(id: number) {
    return this.http.delete(`${this.apiUrlSmtp}/${id}`)
  }
  sendTestMail(templateName: string, eMail: string) {
    return this.http.post(`${this.apiUrlSmtp}/SendTestMail?templateName=${templateName}&eMail=${eMail}`, null)
  }

}
